import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f575c1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "absolute top-0 flex h-full w-full items-center justify-center transition-all"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "absolute top-0 flex h-full w-full flex-col items-center justify-center transition-all"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-[3px] text-center text-[14px] font-bold leading-[136%] text-white/60" }, " 사진을 업로드 해주세요. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-[12px] font-bold leading-[160%] tracking-[-0.015em] text-white/60" }, " (jpg, jpeg 권장) ", -1))
const _hoisted_7 = {
  key: 2,
  class: "absolute top-0 h-full w-full transition-all"
}
const _hoisted_8 = { class: "flex h-full w-full flex-col items-center p-3" }
const _hoisted_9 = { class: "relative mb-3 h-full w-full overflow-hidden rounded-[14px]" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "absolute top-0 flex h-full w-full flex-col items-center justify-center bg-black/40" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "w-full px-6 text-center text-[12px] font-bold leading-[136%] tracking-[-0.015em] text-[#EEEEEE]" }
const _hoisted_14 = { id: "filename" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative flex flex-col items-center justify-center rounded-[20px] border-[2px] border-solid bg-[#333942] transition-all", [
      _ctx.fileInfo.imageUrl.length > 0 ? 'border-[#6150FF]' : 'border-[#333942] cursor-pointer',
      { 'pointer-events-none': _ctx.isLoading },
    ]]),
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleUpload && _ctx.handleUpload(...args)))
  }, [
    _createElementVNode("input", {
      ref: "input",
      type: "file",
      accept: ".png,.jpg,.jpeg",
      hidden: "",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChangeImage && _ctx.onChangeImage(...args)))
    }, null, 544),
    _createVNode(_TransitionGroup, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                src: require('@assets/icons/Loading.svg'),
                class: "animate-spin"
              }, null, 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading && _ctx.fileInfo.imageUrl.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                src: require('@assets/icons/Picture.svg'),
                class: "mb-2"
              }, null, 8, _hoisted_4),
              _hoisted_5,
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading && _ctx.fileInfo.imageUrl.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: _ctx.fileInfo.imageUrl,
                    alt: _ctx.fileInfo.name,
                    class: "relative h-full w-full object-cover"
                  }, null, 8, _hoisted_10),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: require('@assets/icons/Clip.svg'),
                      class: "mb-2"
                    }, null, 8, _hoisted_12),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.fileInfo.name.replace(/\.[^/.]+$/, "")), 1),
                      _createElementVNode("div", null, "." + _toDisplayString(_ctx.fileInfo.type.replace(/(.*)\//g, "")), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "flex h-9 w-9 cursor-pointer items-center justify-center rounded-[6px] bg-[#26292E]",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["stop"]))
                }, [
                  _createElementVNode("img", {
                    src: require('@assets/icons/Trash.svg')
                  }, null, 8, _hoisted_15)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}